/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listingbuttonskindmenu3Inputs */

const en_listingbuttonskindmenu3 = /** @type {(inputs: Listingbuttonskindmenu3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu`)
};

const de_listingbuttonskindmenu3 = /** @type {(inputs: Listingbuttonskindmenu3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speisekarte`)
};

/**
* | output |
* | --- |
* | "Menu" |
*
* @param {Listingbuttonskindmenu3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const listingbuttonskindmenu3 = /** @type {((inputs?: Listingbuttonskindmenu3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listingbuttonskindmenu3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listingbuttonskindmenu3(inputs)
	return de_listingbuttonskindmenu3(inputs)
});
export { listingbuttonskindmenu3 as "listingButtonsKindMenu" }